











import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})

export default class ImportPager extends Vue {
    @Prop() title: string;
    @Prop({ default: 4 }) count: number;
    @Prop({required: true}) current: number;
    @Prop({required: true}) pageTitle: string;
}

